import rsrAlertCircle from '../images/rsr-alert-circle.svg'
import rsrCheckCircle from '../images/rsr-check-circle.svg'
import rsrRepeat from '../images/rsr-repeat.svg'
import rsrLoader from '../images/rsr-loader.svg'
import rsrClock from '../images/rsr-clock.svg'
import rsrWarning from '../images/rsr-alert-triangle.svg'

export const icons = {
  rsr: {
    circle: {
      alert: rsrAlertCircle,
      check: rsrCheckCircle
    },
    repeat: rsrRepeat,
    loader: rsrLoader,
    clock: rsrClock,
    warning: rsrWarning,
  }
}
